import { Component, DestroyRef, inject, Inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { faCheck, faListCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { finalize } from 'rxjs/operators';
import { ErrorService } from '../../../../../../@core/utils/error.service';
import { InventoryService } from '../../../../pick-plan/services/inventory.service';
import { ReasonCode } from '../../../models/reason-code';

export interface MassBalanceRecord {
  date?: string;
  reason?: string;
  balance?: number;
}

export interface ReasonCodeChangerData {
  record: MassBalanceRecord;
  reasonCodes: ReasonCode[];
}

/** Changes the reason on one mass balance entry; closes with true once saved. */
@Component({
  selector: 'reason-code-changer-popup',
  templateUrl: './reason-code-changer-popup.component.html',
  styleUrls: ['./reason-code-changer-popup.component.scss']
})
export class ReasonCodeChangerPopupComponent {

  static open(dialog: MatDialog, data: ReasonCodeChangerData): MatDialogRef<ReasonCodeChangerPopupComponent, boolean> {
    return dialog.open(ReasonCodeChangerPopupComponent, { data, width: '480px', maxWidth: '95vw' });
  }

  public faCheck = faCheck;
  public faListCheck = faListCheck;
  public faXmark = faXmark;

  public isLoading = false;
  public reason: string | undefined;

  private destroyRef = inject(DestroyRef);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReasonCodeChangerData,
    private dialogRef: MatDialogRef<ReasonCodeChangerPopupComponent, boolean>,
    private inventoryService: InventoryService,
    private errorService: ErrorService
  ) {
    this.reason = data.record.reason;
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;
    this.inventoryService.updateMassBalanceReason({ ...this.data.record, reason: this.reason })
      .pipe(finalize(() => this.isLoading = false), takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.data.record.reason = this.reason;
          this.dialogRef.close(true);
        },
        error: err => this.errorService.handleError(err)
      });
  }
}
